import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useTheme, useMediaQuery } from "@mui/material";

const CohortAreaNameComponent = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const getWidth = () => {
    if (isSmallScreen) return "90vw"; // Mobile
    if (isMediumScreen) return "70vw"; // Medium screens
    return "30vw"; // Larger screens
  };

  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ ...styles.box, width: getWidth() }}>
        <p style={styles.label}>
          Area Name <span style={styles.required}>*</span>
        </p>
        <TextField
          fullWidth
          id="area-name"
          label="Enter Area Name"
          variant="standard"
          autoComplete="off"
          value={props.cohortAreaName}
          onChange={props.handleCohortAreaNameChange}
          sx={styles.textField}
        />
        {props.errors?.cohortAreaName && (
          <p style={styles.error}>{props.errors.cohortAreaName}</p>
        )}
      </Box>
    </Box>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "flex-start", // Align to the left
    alignItems: "flex-start", // Align to the top
    minHeight: "100vh",
    backgroundColor: "#FFFFFF",
    padding: "20px",
    boxSizing: "border-box",
    borderRadius: "24px",
  },
  box: {
    padding: "30px 20px",
    borderRadius: "16px",
    textAlign: "left",
    width: "100%", // Ensures the box width is responsive
  },
  label: {
    fontSize: "22px",
    fontWeight: 500,
    marginBottom: "12px",
  },
  required: {
    color: "red",
  },
  textField: {
    "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
    "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
  },
  error: {
    color: "red",
    marginTop: "8px",
    fontSize: "14px",
  },
};

export default CohortAreaNameComponent;
